import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVolumeDown"><Path d="M22.25 12H15.75M3.75 7.74999H5.29844C5.75258 7.74999 6.1932 7.59543 6.54783 7.31173L10.6253 4.04974C11.2801 3.52593 12.25 3.99211 12.25 4.83061V19.1694C12.25 20.0079 11.2801 20.474 10.6253 19.9502L6.54783 16.6883C6.1932 16.4045 5.75258 16.25 5.29844 16.25H3.75C2.64543 16.25 1.75 15.3546 1.75 14.25V9.74999C1.75 8.64542 2.64543 7.74999 3.75 7.74999Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVolumeDown;
